module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "site-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "footer-desc",
    domProps: {
      "innerHTML": _vm._s(this.messages[this.lang].colophon)
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "footer-nav"
  }, [_c('a', {
    attrs: {
      "href": '/contact.html#/' + this.lang
    }
  }, [_vm._v(_vm._s(this.messages[this.lang].contact))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1434c549!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteFooter.vue
// module id = 692
// module chunks = 8